/*
 * reviews-list.js — fills sections/reviews.liquid from the app's PUBLIC
 * reviews endpoint (approved reviews only). Read-only; no writes, no
 * cookies. Product pages: the section is server-hidden and is revealed
 * only when that product has at least one review. Copy lives in Liquid;
 * this file fills values and toggles [hidden].
 */
(function () {
  'use strict';

  function starsText(rating) {
    var r = Math.round(Number(rating) || 0);
    var out = '';
    for (var i = 1; i <= 5; i++) out += i <= r ? '★' : '☆';
    return out;
  }

  function plural(section, n) {
    var key = n === 1 ? 'data-based-1' : n === 2 ? 'data-based-2'
      : (n >= 3 && n <= 10) ? 'data-based-3' : 'data-based-11';
    var sample = key === 'data-based-1' ? '1' : key === 'data-based-2' ? '2'
      : key === 'data-based-3' ? '3' : '11';
    var pattern = section.getAttribute(key) || '';
    return pattern.replace(sample, function () { return String(n); });
  }

  function init(section) {
    // Two Reviews sections on one template load this script twice; init once.
    if (section.getAttribute('data-rv-initialized') === 'true') return;
    section.setAttribute('data-rv-initialized', 'true');
    var base = (section.getAttribute('data-base') || '').replace(/\/+$/, '');
    if (!base) return;
    var product = section.getAttribute('data-product') || '';
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 24;
    var locale = section.getAttribute('data-locale') || 'en';
    var root = (section.getAttribute('data-root') || '/').replace(/\/+$/, '');
    var starsLabel = section.getAttribute('data-stars-label') || '';
    var tpl = section.querySelector('[data-rv-card]');
    var list = section.querySelector('[data-rv-list]');
    if (!tpl || !list) return;

    var dateFmt = null;
    try {
      dateFmt = new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) { /* toDateString fallback */ }
    var numFmt = null;
    try {
      numFmt = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    } catch (e) { /* toFixed fallback */ }

    function q(sel) { return section.querySelector(sel); }
    function show(node, on) { if (node) node.hidden = !on; }

    function card(review) {
      var li = tpl.content.firstElementChild.cloneNode(true);
      var rating = Math.max(1, Math.min(5, Math.round(Number(review.rating) || 0)));
      var stars = li.querySelector('[data-c-stars]');
      stars.textContent = starsText(rating);
      stars.setAttribute('aria-label', starsLabel.replace('[[r]]', String(rating)));
      li.querySelector('[data-c-text]').textContent = review.comment ? '“' + review.comment + '”' : '';
      li.querySelector('[data-c-name]').textContent = review.name || '';
      var d = new Date(review.date);
      li.querySelector('[data-c-date]').textContent =
        isNaN(d.getTime()) ? '' : (dateFmt ? dateFmt.format(d) : d.toDateString());
      var items = li.querySelector('[data-c-items]');
      if (!product && Array.isArray(review.items) && review.items.length) {
        for (var i = 0; i < review.items.length; i++) {
          var it = review.items[i];
          if (!it || !it.title) continue;
          var a = document.createElement('a');
          a.className = 'reviews__item';
          a.textContent = it.title;
          if (it.handle) a.href = root + '/products/' + encodeURIComponent(it.handle);
          items.appendChild(document.createTextNode(' '));
          items.appendChild(a);
        }
        items.hidden = false;
      }
      return li;
    }

    var url = base + '/reviews?limit=' + limit + (product ? '&product=' + encodeURIComponent(product) : '');
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        show(q('[data-rv-loading]'), false);
        if (!data || !Array.isArray(data.reviews)) throw new Error('bad payload');
        var reviews = data.reviews;
        var summary = data.summary || {};
        var count = Number(summary.count) || reviews.length;
        if (!reviews.length) {
          if (product) return; // product page: stay hidden, nothing to say
          show(q('[data-rv-empty]'), true);
          return;
        }
        var avg = Number(summary.average) || 0;
        var avgEl = q('[data-rv-avg]');
        if (avgEl) avgEl.textContent = numFmt ? numFmt.format(avg) : avg.toFixed(1);
        var avgStars = q('[data-rv-avg-stars]');
        if (avgStars) {
          avgStars.textContent = starsText(avg);
          avgStars.setAttribute('aria-label', starsLabel.replace('[[r]]', avgEl ? avgEl.textContent : String(avg)));
        }
        var countEl = q('[data-rv-count]');
        if (countEl) countEl.textContent = plural(section, count);
        show(q('[data-rv-summary]'), true);

        var frag = document.createDocumentFragment();
        for (var i = 0; i < reviews.length; i++) frag.appendChild(card(reviews[i]));
        list.appendChild(frag);
        show(list, true);
        show(q('[data-rv-foot]'), true);
        section.hidden = false;
      })
      .catch(function () {
        show(q('[data-rv-loading]'), false);
        if (!product) show(q('[data-rv-error]'), true);
      });
  }

  function boot() {
    var sections = document.querySelectorAll('[data-reviews]');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
